<template>
    <v-container>
        <v-layout justify-center>
            <v-flex xs12 sm10 md8>
                <v-card class="mt-5 mb-10 elevation-12">
                    <v-card-text class="subtitle-1">
                        <v-form ref="form" v-model="valid">
                            <v-text-field
                                prepend-icon="mdi-email"
                                name="email"
                                label="Email"
                                type="email"
                                v-model="email"
                                :rules="emailRules"
                                required
                            >
                            </v-text-field>
                            <v-text-field
                                prepend-icon="mdi-lock"
                                name="password"
                                label="Password"
                                type="password"
                                v-model="password"
                                :rules="passwordRules"
                                required
                            >
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small to="/">
                            Back to archive
                        </v-btn>
                        <v-btn
                            small
                            :disabled="!valid"
                            @click="submit"
                            >Login</v-btn
                        >
                    </v-card-actions>
                </v-card>
                
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'LogIn',
    data() {
        return {
            valid: false,
            email: '',
            password: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v =>
                    v.length >= 6 ||
                    'Password must be greater than 6 characters'
            ]
        };
    },
    metaInfo() {
      return { 
          title: 'Admin Area | Meditatio Talks Series'
      }
    },     
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('userLogin', {
                    email: this.email,
                    password: this.password
                });
            }
        }
    }
};
</script>